import captureSvg from "../../Assets/icon/tabbar/capture.svg";
import menuSvg from "../../Assets/icon/tabbar/menu.svg";
import shard1 from "../../Assets/icon/tabbar/aris-shard1.png";
import shard2 from "../../Assets/icon/tabbar/aris-shard2.png";
import shard3 from "../../Assets/icon/tabbar/aris-shard3.png";
import mask1a from "../../Assets/icon/tabbar/aris-mask1a.svg";
import mask1b from "../../Assets/icon/tabbar/aris-mask1b.svg";
import mask2a from "../../Assets/icon/tabbar/aris-mask2a.svg";
import mask2b from "../../Assets/icon/tabbar/aris-mask2b.svg";
import mask3a from "../../Assets/icon/tabbar/aris-mask3a.svg";
import mask3b from "../../Assets/icon/tabbar/aris-mask3b.svg";

// Bottom-tab icons (Figma 9862:23510). Explore and Journey are inline so they
// follow `currentColor`; Capture and Menu are the exported Figma SVGs used as
// a mask over `currentColor`, so the asset is untouched and still themeable.

export function ExploreIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.9" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.9" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.9" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.9" />
    </svg>
  );
}

export function JourneyIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7 21c0-4 3-5.5 5.5-6.5S18 12 18 8.5A3.5 3.5 0 0014.5 5c-2 0-3.5 1.4-3.5 3.2 0 1.6 1.2 2.8 2.8 2.8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="17.5" cy="3.5" r="1.6" fill="currentColor" />
    </svg>
  );
}

const MaskIcon = ({ src }) => (
  <span
    className="aris-tabbar__mask-icon"
    style={{ WebkitMaskImage: `url("${src}")`, maskImage: `url("${src}")` }}
    aria-hidden="true"
  />
);

export const CaptureIcon = () => <MaskIcon src={captureSvg} />;
export const MenuIcon = () => <MaskIcon src={menuSvg} />;

/**
 * The Aris mark in the raised centre button: three gradient shards, each
 * clipped by the two masks Figma composes it with. Offsets and sizes are the
 * design's own (node 10003:6519), so the mark matches it exactly.
 */
const SHARDS = [
  {
    src: shard1,
    masks: [mask1a, mask1b],
    left: 2.67 - 1.13 - 0.01,
    top: 9.53 - 1.12 - 0.11,
    width: 10.771,
    height: 7.216,
    position: "1.141px 1.226px, 0.014px 0.105px",
    size: "8.448px 4.791px, 10.692px 7.037px",
  },
  {
    src: shard2,
    masks: [mask2a, mask2b],
    left: 5.63 - 1.12 - 0.06,
    top: 0 - 1.12 - 0.05,
    width: 13.248,
    height: 16.694,
    position: "1.181px 1.166px, 0.057px 0.047px",
    size: "10.892px 14.327px, 13.136px 16.571px",
  },
  {
    src: shard3,
    masks: [mask3a, mask3b],
    left: 0 - 1.13 - 0.03,
    top: 9.58 - 1.12 - 0.05,
    width: 9.801,
    height: 10.771,
    position: "1.154px 1.167px, 0.029px 0.046px",
    size: "7.515px 8.417px, 9.759px 10.661px",
  },
];

export function ArisMark() {
  return (
    <span className="aris-tabbar__mark" aria-hidden="true">
      {SHARDS.map((s) => {
        const mask = s.masks.map((m) => `url("${m}")`).join(", ");
        return (
          <span
            key={s.src}
            className="aris-tabbar__shard"
            style={{
              left: `${s.left}px`,
              top: `${s.top}px`,
              width: `${s.width}px`,
              height: `${s.height}px`,
              WebkitMaskImage: mask,
              maskImage: mask,
              WebkitMaskPosition: s.position,
              maskPosition: s.position,
              WebkitMaskSize: s.size,
              maskSize: s.size,
              backgroundImage: `url("${s.src}")`,
            }}
          />
        );
      })}
    </span>
  );
}
